import { NgMessage } from './ng-message';

export class NgMessageMap {
  [messageCode: number]: NgMessage;
}
